import { ShortcodeSummary } from "../../../Model/Shortcode/ShortcodeSummary";
import { currencyPrettyPrint } from "../../../Model/Configuration/CurrencyConfiguration";
import * as React from "react";
import { ApplicationContext } from "../../../ApplicationContext";
import { useState } from "react";

interface ShortcodeResultsProps {
    shortcodeSummary: ShortcodeSummary | undefined
}

const ShortcodeResults= (props: ShortcodeResultsProps): JSX.Element | null => {
    const applicationContext = React.useContext(ApplicationContext)
    const [expanded, setExpanded] = useState(false)
    const shortcodeSummary = props.shortcodeSummary
    if (!shortcodeSummary) return null

    return <>
        <div>
            <h3 className="sp-text-primary">Three UK</h3>

            <div className="shortcode-grid">
                <div className="shortcode-gridItem shortcode-item-0">
                    <h5 className="sp-text-primary shortcode-label">Shortcode:</h5>
                    <p className="">{shortcodeSummary.shortcode}</p>
                </div>
                <div className="shortcode-gridItem shortcode-item-1">
                    <h5 className="sp-text-primary shortcode-label">Outgoing message cost:</h5>
                    <p className="">
                        {currencyPrettyPrint(shortcodeSummary.outgoingMessageCost,
                            applicationContext.appConfig.currencyConfiguration)}
                    </p>
                </div>
                <div className="shortcode-gridItem shortcode-item-2">
                    <h5 className="sp-text-primary shortcode-label">Service type:</h5>
                    <p className="">{shortcodeSummary.serviceType}</p>
                </div>
                <div className="shortcode-gridItem shortcode-item-3">
                    <h5 className="sp-text-primary shortcode-label">Incoming message cost:</h5>
                    <p className="">
                        {currencyPrettyPrint(shortcodeSummary.incomingMessageCost,
                            applicationContext.appConfig.currencyConfiguration)}
                    </p>
                </div>
            </div>

            <hr className="divider"/>

            <h3 className="sp-text-primary">Questions about this shortcode?</h3>
            <p>Here's the contact info you need:</p>

            <div className="shortcode-grid">
                <div className="shortcode-gridItem shortcode-item-0">
                    <h5 className="sp-text-primary shortcode-label">Email/Website:</h5>
                    <p className="">{shortcodeSummary.customerCareContactEmail}</p>
                </div>
                <div className="shortcode-gridItem shortcode-item-1">
                    <h5 className="sp-text-primary shortcode-label">Phone number:</h5>
                    <p className="">{shortcodeSummary.customerCareContactPhone}</p>
                </div>

                <button className="shortcode-accordion-button sp-text-primary shortcode-label"
                        onClick={() => setExpanded(!expanded)}>
                    <h5>Payment intermediary details {expanded ? "▲" : "▼"}</h5>
                </button>
                <br/>

                { expanded &&
                    <>
                        <div className="shortcode-gridItem shortcode-item-2">
                            <h5 className="sp-text-primary shortcode-label">Email/Website:</h5>
                            <p className="">{shortcodeSummary.customerCareEscalationEmail}</p>
                        </div>
                        <div className="shortcode-gridItem shortcode-item-3">
                            <h5 className="sp-text-primary shortcode-label">Phone number:</h5>
                            <p className="">{shortcodeSummary.customerCareEscalationPhone}</p>
                        </div>
                    </>
                }
            </div>
        </div>
    </>
}

export default ShortcodeResults